import {HttpStatusCode} from 'axios';
import {t} from 'i18next';
import {DisplayMessageTypes} from '../lib/enums';
import {Result, DisplayMessage} from '../lib/interfaces';
import {getWeddingOfficiantsApi} from './apiServices';

export async function getWeddingOfficiants(): Promise<Result<any, DisplayMessage>> {
  const response = await getWeddingOfficiantsApi();
  if (response.status === HttpStatusCode.Ok) {
    return {
      data: response.data,
      info: null,
    } as Result<any, DisplayMessage>;
  } else {
    return {
      data: null,
      info: {
        type: DisplayMessageTypes.Error,
        message: t('message.INTERNAL_ERROR'),
        visible: true,
      },
    } as Result<any, DisplayMessage>;
  }
}
